import { FormQuestions } from "../../shared/types";
import { RepairerOptionsFormValues } from "./types";

export const RepairerOptionsQuestions = {
  selectedRepairer: {
    id: "selected-repairer",
    name: "selectedRepairer",
  },
} as const satisfies FormQuestions<RepairerOptionsFormValues>;
